import styled from "styled-components/macro";

// The Paid pill includes the amount.
// We decided not to show the amount here to protect privacy of donation amounts.
export default function DonatedTooltipContent({
  goToProfileGivingTab,
  showProfileLinkIcon,
  status,
  markedPaidName,
  otherPersonPaid,
  payerName,
}) {
  if (status === "MarkedAsPaid") {
    return (
      <div>
        Marked as donated by <strong>{markedPaidName}</strong>
      </div>
    );
  }

  if (status === "Paid")
    return (
      <div>
        {/* <div> */}
        {otherPersonPaid && payerName ? (
          <span>
            <strong>{payerName}</strong> made a donation via Flocknote
          </span>
        ) : (
          "Donated via Flocknote"
        )}
        {showProfileLinkIcon ? (
          <IconButton onClick={goToProfileGivingTab}>
            <i className="far fa-link" />
          </IconButton>
        ) : null}
      </div>
    );

  return null;
}

const IconButton = styled.button`
  background: none;
  color: var(--donationPillPopoverText);
  border: none;

  &:hover {
    cursor: pointer;
  }
`;
